import { findBand, BAND_COLORS } from "../bands";

// DAPSA / cDAPSA — Disease Activity in PSoriatic Arthritis.
// cDAPSA ("clinical") is DAPSA without the CRP term.
// ⚠️ Verify clinically before relying on results.
const dapsaBands = [
    { label: "Remission", color: BAND_COLORS.remission, lte: 4 },
    { label: "Low", color: BAND_COLORS.low, lte: 14 },
    { label: "Moderate", color: BAND_COLORS.moderate, lte: 28 },
    { label: "High", color: BAND_COLORS.high },
];

const cdapsaBands = [
    { label: "Remission", color: BAND_COLORS.remission, lte: 4 },
    { label: "Low", color: BAND_COLORS.low, lte: 13 },
    { label: "Moderate", color: BAND_COLORS.moderate, lte: 27 },
    { label: "High", color: BAND_COLORS.high },
];

export const dapsa = {
    id: "dapsa",
    name: "DAPSA/cDAPSA",
    subtitle: "Disease activity in psoriatic arthritis",
    group: "Psoriatic arthritis",
    status: "ready",
    options: [
        { key: "type", label: "Activity index", choices: ["cDAPSA", "DAPSA"], default: "cDAPSA" },
    ],
    fields: [
        { key: "sjc66", label: "Swollen joint count (SJC)", unit: "joints", type: "number", min: 0, max: 66 },
        { key: "tjc68", label: "Tender joint count (TJC)", unit: "joints", type: "number", min: 0, max: 68 },
        { key: "pain", label: "Patient pain (PP) assessment", unit: "cm", type: "number", min: 0, max: 10, step: 0.1 },
        { key: "ptga", label: "Patient global assessment (PtGA)", unit: "cm", type: "number", min: 0, max: 10, step: 0.1 },
        {
            key: "crp",
            label: "CRP",
            unit: "mg/dL",
            type: "number",
            min: 0,
            max: 50,
            step: 0.1,
            showIf: (o) => o.type === "DAPSA",
        },
    ],
    compute: (v, o) => {
        const base = v.tjc68 + v.sjc66 + v.ptga + v.pain;
        return o.type === "DAPSA" ? base + v.crp : base;
    },
    interpret: (score, o) => findBand(score, o.type === "DAPSA" ? dapsaBands : cdapsaBands),
    bands: (o) => (o.type === "DAPSA" ? dapsaBands : cdapsaBands),
    about:
        "Composite disease activity indices provide a consistent way of measuring disease activity in psoriatic arthritis and can facilitate informed treatment decisions. The clinical Disease Activity index for PSoriatic Arthritis (cDAPSA) integrates four components: swollen joint count (SJC), tender joint count (TJC), patient's assessment of pain severity (PP) and patient's global assessment of disease activity (PtGA), each global on a 0–10 cm scale. The score categorises disease activity into remission, low, moderate or high. DAPSA adds CRP (mg/dL) to the same sum. Both are preferred composite indices for the treat-to-target (T2T) approach and are endorsed by the EULAR recommendations on management of psoriatic arthritis.",
    references: [
        "Schoels M, et al. Application of the DAREA/DAPSA score for assessment of disease activity in psoriatic arthritis. Ann Rheum Dis. 2010.",
        "Schoels MM, et al. Disease activity in psoriatic arthritis (DAPSA): defining remission and treatment success. Ann Rheum Dis. 2016.",
    ],
};
